module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_speed.f9433b22.png";